module.exports = __webpack_public_path__ + "assets/fonts/Gotham-BoldItalic.19c3c642.otf";